import { motion, useReducedMotion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function RatesDestinationBridge() {
  const ref = useRef<HTMLElement>(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      ref={ref}
      id="destination"
      aria-labelledby="rates-destination-heading"
      className="relative isolate overflow-hidden bg-primary text-primary-foreground"
    >
      <div className="overlay-forest absolute inset-0 -z-10" />

      <div className="shell py-18 md:py-24">
        <Reveal>
          <Eyebrow tone="light">Make the Most of Your Stay</Eyebrow>
        </Reveal>
        <h2 id="rates-destination-heading" className="display-lg mt-6 max-w-[14ch]">
          <MaskReveal>Stay Longer.</MaskReveal>
          <MaskReveal delay={0.08}>Explore More.</MaskReveal>
        </h2>
        <Reveal delay={0.12}>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-primary-foreground/80 md:text-lg">
            From Auburn&apos;s Gold Country history to the American River and Sierra Foothill
            trails, staying a little longer gives you more time to experience everything surrounding
            Auburn RV Resort.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
            <ResortLink variant="gold" href="/nearby-attractions/" className="w-full sm:w-auto">
              Explore Nearby Attractions
            </ResortLink>
            <ResortLink variant="onDark" href="/accommodations/" className="w-full sm:w-auto">
              View Our RV Sites
            </ResortLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
